import * as constants from './PlvLiveRedirect.constants';
import * as services from './PlvLiveRedirect.service';

const state = {
  plvWatchLink: '',
};

const mutations = {
  [constants.GET_PLV_WATCH_LINK_SUCCESS](state, plvWatchLink) {
    if (undefined !== plvWatchLink && null !== plvWatchLink) {
      state.plvWatchLink = plvWatchLink;
    }
  },
};

const actions = {
  async getPlvWatchLink({ commit }, payload) {
    const res = await services.getPlvWatchLink(payload);
    commit(constants.GET_PLV_WATCH_LINK_SUCCESS, res.data.data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
